import throttle from 'lodash/throttle'

import { makePageSingleton } from '@app/adapters/singleton/page'

export class ScrollingServiceKlass {
  #handlers = new Set<() => void>()
  #scrollableElement?: HTMLElement | null | Window
  #throttleInterval: number

  constructor(
    scrollableElement: HTMLElement | null | Window,
    throttleInterval: number
  ) {
    this.#scrollableElement = scrollableElement
    this.#throttleInterval = throttleInterval
  }

  registerHandler(handler: () => void): () => void {
    const throttled = throttle(() => {
      handler()
    }, this.#throttleInterval)

    this.#handlers.add(throttled)

    this.attachHandler(throttled)

    return this.unregisterHandler.bind(this, throttled)
  }

  unregisterHandler(handler: () => void): void {
    this.#handlers.delete(handler)
    this.#scrollableElement?.removeEventListener('scroll', handler)
  }

  private attachHandler(handler: () => void): void {
    this.#scrollableElement?.addEventListener('scroll', handler, {
      passive: true,
    })
  }

  teardown = (): void => {
    this.#handlers.forEach((handler) => {
      this.#scrollableElement?.removeEventListener('scroll', handler)
    })

    this.#handlers.clear()
  }
}

export const ScrollingService = makePageSingleton(
  (scrollableElement: HTMLElement | null | Window, throttleInterval: number) =>
    new ScrollingServiceKlass(scrollableElement, throttleInterval)
)
